import type { NextPage } from "next";
import { en as locale } from "@/helpers/translationTexts";
import BaseHeader from "@/components/BaseHeader";
import AwardsContent from "@/components/AwardsContent/AwardsContent";

const Awards: NextPage = () => {
  return (
    <>
      <BaseHeader title={locale.awardsMetaTitle} description={locale.awardsMetaDescription} />
      <AwardsContent />
    </>
  );
};

export default Awards;
